import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { IError } from '@unfoldrtech/portal-mic'
import { AxiosError, AxiosResponse } from 'axios'
import { ICategoryAttributionUpdate } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId } from '../utils/helpers/generateCorrelationId'
import { coreAPIV3 } from '../services/coreAPIV3'

type TPutCategoryAttributionMutationResult = UseMutationResult<
  AxiosResponse<void>,
  AxiosError<IError>,
  { payload: ICategoryAttributionUpdate }
>

export default function usePutCategoryAttribution(params: {
  retailerId: number
  categoryAttributionId: number
}) {
  return useMutation(
    [
      `usePutCategoryAttribution_${params.retailerId}_${params.categoryAttributionId}`,
    ],
    ({ payload }) => {
      return coreAPIV3
        .retailerInventory()
        .putCategoryAttribution(
          params.retailerId,
          params.categoryAttributionId,
          generateCorrelationId(),
          payload
        )
    }
  ) as TPutCategoryAttributionMutationResult
}
